import config from '../common/config';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Grid, Cell } from 'react-flexr';
import { SearchPanel, SearchGroup, Slider } from '../common/search';
import * as date from '../utils/date-fns';

import ProductCategory from '../common/product-category';
import Showcase from '../common/showcase';

import { fromJS } from 'immutable';
import TagFilter from '../common/tagFilter';

const DEFAULT_PRICE = 400;
const UNLIMITED_PRICE = 601;

const DEFAULT_CHANNELS = 25;
const UNLIMITED_CHANNELS = 51;
const ALL_CHANNELS = 14;

class Offers extends ProductCategory {
  static defaultProps = {
    category: 'tv'
  };

  constructor(props) {
    super(props);

    this.state = this.mapPropsToState(props, {
      offerType: 'tv-udbydere',
      ...this.state,
      sort: this.createSort({ weight: -1, 'price.monthly': 1 }),
      defaultFilters: { // FOR FILTERS_USED EPI
        price: null,
        channels: null
      },
      filters: {
        price: null,
        channels: null,
        tags: [],
        ...(this.state.filters || {})
      }
    });
  }

  resetFilter() {
    const filters = {
      ...(this.state.filters || {}),
      tags: [],
      price: null,
      channels: null
    };
    
    this.setState({
      filters,
      filter: this.createFilter(filters)
    });
  }


  createFilter(filters) {
    this.updateFiltersUsed(filters);
    return offers =>
      offers.filter(offer => {
        const tags = Array.from(offer.get('usps'));
        const services = Array.from(offer.getIn(['_raw', 'services']));
        const filteredTags = filters.tags;
        
        const lowerCaseTags = tags.map(i => i.toLowerCase());
        const lowerCaseServices = services.map(i => i.toLowerCase());
        const lowerCaseProvider = offer.get('provider').toLowerCase().trim().replace('-', ' ');

        for (let idx = 0; idx < filteredTags.length; idx++) {
          const tag = filteredTags[idx];
          if (
            !lowerCaseServices.includes(tag) &&
            !lowerCaseTags.includes(tag) && 
            !tags.includes(tag) &&
            !services.includes(tag) &&
            tag.toLowerCase() !== lowerCaseProvider) {
            return false;
          }
        }

        if (filters.price !== null) {
          if (
            filters.price !== UNLIMITED_PRICE &&
            offer.getIn(['_raw', 'price', 'monthly']) > filters.price
          ) {
            return false;
          }
        }

        if (filters.channels !== null) {
          if (
            filters.channels !== ALL_CHANNELS &&
            offer.getIn(['_raw', 'channels', 'amount']) < filters.channels
          ) {
            return false;
          }
        }

        return true;
      });
  }

  serialiseOffer(offer) {
    const remark = `Mindsteprisen er ${offer.getIn([
      'price',
      'contractPeriod'
    ])} kr.`;
    // if (offer.get('period') == 6) {
    //   remark = `6 måneders binding, hvor mindsteprisen i perioden er ${offer.getIn(['price', 'sixMonths'])} kr.`;
    // } else {
    //   remark = `${offer.get('period')} ${offer.get('period') === 1 ? 'måneds' : 'måneders'} binding, hvor mindsteprisen i perioden er ${offer.getIn(['price', 'contractPeriod'])} kr. og prisen for 6 måneder er ${offer.getIn(['price', 'sixMonths'])} kr. *`;
    // }

    const remarks = remark
      ? {
          headline: 'Omkostninger:',
          text: remark
        }
      : null;
      const tags = offer.get('tags') ? offer.get('tags').toJS() : [];
      const manualTags = offer.get('manualTags') ? Array.from(offer.get('manualTags')) : [];
      const mergedTags = tags.reduce((acc, tag) => {
        if(!acc.includes(tag)) {
          acc.push(tag);
        }
        return acc;
      }, manualTags || []).filter(Boolean);

    return fromJS({
      id: offer.get('_id'),

      provider: offer.get('provider'),
      // logo: `${config.path.images}/${offer.get('imageUrl')}`,
      logo:
        offer.getIn(['image', 'hash']) &&
        `${config.images}${offer.getIn(['image', 'hash'])}`,
      link: `/redirect/${offer.get('uuid')}`,

      tagline: offer.get('tagline'),
      expire: date.format(offer.get('expire'), 'D. MMM'),

      orderText: 'Se TV kanaler',

      details: [
        {
          value: offer.get('product'),
          label: 'Produkt'
        },
        {
          value: offer.getIn(['channels', 'amount']),
          label: 'Kanaler',
          labelAbove: true
        },
        {
          value: offer.getIn(['price', 'discountStartup']) &&
          offer.getIn(['price', 'discountStartup']) < offer.getIn(['price', 'startupFee'])
            ? offer.getIn(['price', 'discountStartup'])
            : offer.getIn(['price', 'startupFee']),
          label: 'Oprettelse',
          unit: 'kr.',
          labelAbove: true,
          old:
            offer.getIn(['price', 'discountStartup']) &&
            offer.getIn(['price', 'discountStartup']) < offer.getIn(['price', 'startupFee'])
              ? offer.getIn(['price', 'startupFee'])
              : null
        }
      ],

      price: {
        value: offer.getIn(['price', 'discountMonthly']) &&
        offer.getIn(['price', 'discountMonthly']) < offer.getIn(['price', 'monthly'])
          ? offer.getIn(['price', 'discountMonthly'])
          : offer.getIn(['price', 'monthly']),
        unit: 'kr.',
        label: 'Pris pr. md.',
        old:
          offer.getIn(['price', 'discountMonthly']) &&
          offer.getIn(['price', 'discountMonthly']) < offer.getIn(['price', 'monthly'])
            ? offer.getIn(['price', 'monthly'])
            : null
      },

      remarks,
      usps: []
        .concat(mergedTags, offer.get('services').toJS())
        .filter(Boolean),

      _raw: offer
    });
  }

  createSearchDisplay(filters) {
    const display = [];

    if (filters.price) {
      display.push(`Maks pris ${filters.price} kr.`);
    }
    if (filters.channels) {
      display.push(`${filters.channels} kanaler`);
    }
    return display;
  }

  headlinePrice(price) {
    if (price) {
      if (price[0] == UNLIMITED_PRICE) {
        return 'Alle';
      } else {
        return `${parseInt(price[0])} kr.`;
      }
    }
    return '';
  }

  headlineChannels(channels) {
    if (channels) {
      if (channels[0] == ALL_CHANNELS) {
        return 'Alle';
      } else if (channels[0] == UNLIMITED_CHANNELS) {
        return `${UNLIMITED_CHANNELS - 1}+`;
      } else {
        return `${parseInt(channels[0])}`;
      }
    }
    return '';
  }

  render() {
    const { offers, filter, filters, showcases } = this.state;
    // const { providers } = this.state.filters;

    // const isPalm = findMatch('palm');

    return (
      <Grid>
        <Cell size='3/12' portable='1/1'>
          <SearchPanel
            title={'TV udbyder'}
            filter={filter}
            results={offers}
            filterTexts={this.createSearchDisplay(filters)}
          >
            <SearchGroup>
              <Slider
                name='price'
                connect='lower'
                disconnected={filters.price === null}
                headline={[
                  'Pris (max pr. md.)',
                  val => (filters.price === null ? '' : this.headlinePrice(val))
                ]}
                units={['100 kr', `${UNLIMITED_PRICE - 1} kr. | Alle`]}
                min={0}
                max={1000}
                range={{
                  min: [100, 50],
                  '50%': [DEFAULT_PRICE, 50],
                  max: [UNLIMITED_PRICE]
                }}
                defaultStart={[filters.price || DEFAULT_PRICE]}
                onSlide={this.sliderOnChange}
              />
            </SearchGroup>

            <SearchGroup>
              <Slider
                name='channels'
                connect='lower'
                disconnected={filters.channels === null}
                headline={[
                  'Kanaler',
                  val =>
                    filters.channels === null ? '' : this.headlineChannels(val)
                ]}
                units={[
                  `Alle | ${ALL_CHANNELS + 1}`,
                  `${UNLIMITED_CHANNELS - 1}+`
                ]}
                range={{
                  min: [ALL_CHANNELS, 1],
                  '2%': [ALL_CHANNELS + 1, 5],
                  '50%': [DEFAULT_CHANNELS, 5],
                  max: [UNLIMITED_CHANNELS]
                }}
                defaultStart={[filters.channels || DEFAULT_CHANNELS]}
                onSlide={this.sliderOnChange}
              />
            </SearchGroup>
            <TagFilter
              headline={'Tags'}
              feed={this.state.feed}
              offerType={this.state.offerType}
              items={offers}
              filters={filters}
              checkboxOnChange={this.tagsOnChange}
            />
          </SearchPanel>
        </Cell>
        <Cell style={{ width: '100%' }}>
          <Showcase list={showcases} orderText='Se Tilbud' site_id={this.state.siteId} feed={this.state.feed} url={this.state.url} filters_used={this.state.filtersUsed}/>
          {this.renderResults(null, this.resetFilter.bind(this))}
        </Cell>
      </Grid>
    );
  }
}

export default connect(({ tv: { offers } }) => ({ offers }))(
  withRouter(Offers)
);
